import { HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { d } from '@angular/core/src/render3';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentInvoicingPropiosV3Service {
  private readonly urlBase = '/api/';

  constructor(private httpClient: HttpClient) { }

  getSatCatalogProp3(id_user,role,businessId): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'getSatCatalogPropV3?id_user=' +id_user + '&role=' + role + '&businessId='+ businessId);
  }

  getPaymentsToInvoiceProp3(businessId: number, registration: string,role:number,month,inst_id, year): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'getPaymentsToInvoicePropV3?businessId=' + businessId + '&registration=' + registration + '&role=' + role +'&month=' + month +'&inst_id=' +inst_id + '&year=' + year);
  }

  generateStampProp3(data): Observable<any>{
    return this.httpClient.post<any>(this.urlBase + 'generateStampPropV3',data);
  }
  
  extractInfoNodeXmlProp3(data): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'extractInfoNodeXmlPropV3?businessId='+ data.businessId 
                                                          + '&dirXmlInvo='         + data.dirXmlInvo 
                                                          + '&invoiceId='          + data.invoiceId 
                                                          + '&isGlobal='           + data.isGlobal 
                                                          + '&fiscalInstId='       + data.fiscalInstId 
                                                          + '&isInvoiceCanceled='  + data.isInvoiceCanceled);
  }

  constructPDFToXmlProp3(data): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'constructPDFToXmlPropV3?id='      + data.id 
                                                          + '&registration='        + data.registration 
                                                          + '&business='            + data.business 
                                                          + '&businessId='          + data.businessId 
                                                          + '&dirXmlInvo='          + data.dirXmlInvo 
                                                          + '&isInvoiceCanceled='   + data.isInvoiceCanceled
                                                          + '&name_file='           + data.name_file
                                                          + '&createdBy='           + data.createdBy
                                                          + '&isCancel='            + data.isCancel
                                                          + '&isGlobal='            + data.isGlobal
                                                          + '&es_global='           + data.es_global
                                                          + '&uuid='                + data.uuid
                                                          );
  }

  savePDFProp3(data):Observable<any>{
    return this.httpClient.post<any>(this.urlBase + 'savePDFPropV3', data);
  }

  viewInvoiceProp3(data):Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'viewInvoicePropV3?business='+data.business+'&registration=' +data.registration+ '&name_file=' + data.name_file);
  }
  
  verifyDocumentInvoiceProp3(data){
    return this.httpClient.get<any>(this.urlBase + "verifyDocumentInvoicePropV3?business=" + data.business 
                                                                  + "&registration=" + data.registration 
                                                                  + "&name_file="    + data.name_file 
                                                                  + '&error_sat='    + data.error_sat 
                                                                  + '&createdBy='    + data.createdBy
                                                                  + '&businessId='   + data.businessId
                                                                  + '&isGlobal='     + data.isGlobal);
  }

  deleteXmlProp3(data){
    return this.httpClient.post<any>(this.urlBase + "deleteXmlPropV3?dirNamArch=" + data.dirNamArch
                                                          + '&dirNamCFDI='  + data.dirNamCFDI
                                                          + '&dirRespServ=' + data.dirRespServ
                                                          + '&dirXmlInvo='  + data.dirXmlInvo,data);
  }

  getStateProp3(businessId): Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getStatePropV3?businessId="+ businessId );
  }

  getMunicipalityProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getMunicipalityPropV3?idState="  + data.idState + 
                                                                  '&role='            + data.role   + 
                                                                  '&businessId='      + data.businessId +
                                                                  '&idMunicipality='  + data.idMunicipality);
  }
  getSuburbProp3(data): Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getSuburbPropV3?businessId=" + data.businessId + 
                                                              '&role='       + data.role       +
                                                              '&idCol='      + data.idCol      +
                                                              '&type='       + data.type       +
                                                              '&postalCode=' + data.postalCode);
  }
  getCatalogFiscal3(data): Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getCatalogFiscalV3?businessId=" + data.businessId + 
                                                              '&id='         + data.id      +
                                                              '&type='       + data.type    );
  }

  postSaveDataFiscalProp3(data){
    return this.httpClient.post<any[]>(this.urlBase + "postSaveDataFiscalPropV3",data);
  }

  postSaveDataFiscalBusinessProp3(data){
    return this.httpClient.post<any[]>(this.urlBase + "postSaveDataFiscalBusinessPropV3",data);
  }

  getFiscalDataProp3(registration:string,role:number,businessId:number):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getFiscalDataPropV3?registration=" + registration + '&role='+ role + '&businessId='+ businessId);
  }

  postDeleteFiscalDataProp3(data):Observable<any[]>{
    return this.httpClient.post<any[]>(this.urlBase + "postDeleteFiscalDataPropV3",data);
  }

  getInvoiceByIdProp3(idUser:number,role:number):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getInvoiceByIdPropV3?idUser=" + idUser + '&role=' + role);
  }

  getInvoicesCanceledProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getInvoicesCanceledPropV3?registration=" + data.registration  +
                                                                              '&role='        + data.role          +
                                                                              '&businessId='  + data.businessId);
  }

  postDemandCancellationProp3(data):Observable<any[]>{
    return this.httpClient.post<any[]>(this.urlBase + "postDemandCancellationPropV3?id=" + data.id           +
                                                                '&modifiedBy='     + data.modifiedBy   +
                                                                '&registration='   + data.registration +
                                                                '&folio='          + data.folio        +
                                                                '&createdBy='      + data.createdBy    +
                                                                '&userId='         + data.userId ,data);
  }

  getInstitutions3(businessName):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getPropiosInstitutionsV3?businessName=" + businessName);
  }

  getInvoiceFilterSearchProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getInvoiceFilterSearchPropV3?inst_id=" +  data.instId    +
                                                                        '&businessId=' + data.businessId +
                                                                        '&role='       + data.role       +
                                                                        '&idUser='       + data.idUser    );
  }

  cancelInvoiceProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "cancelInvoicePropV3?username="       + data.username     + 
                                                                    '&uuid='         + data.uuid         +    
                                                                    '&invoice='      + data.invoice      + 
                                                                    '&id='           + data.id           + 
                                                                    '&business_id='  + data.business_id  + 
                                                                    '&registration=' + data.registration + 
                                                                    '&xml='          + data.xml          +
                                                                    '&isGlobal='     + data.isGlobal     +
                                                                    '&createdBy='    + data.createdBy    +
                                                                    '&role='         + data.role    );
  }

  getSearchReasonSocialProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getSearchReasonSocialPropV3?registration=" + data.registration +
                                                                          '&description='  + data.description  +  
                                                                          '&role='         + data.role         +
                                                                          '&index='        + data.index        +
                                                                          '&businessId='   + data.businessId   );
  }

  getBusinessStudentsProp3(businessId:number):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getBusinessStudentsPropV3?businessId=" + businessId);
  }

  getRebillingProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getRebillingPropV3?businessId="       + data.businessId        + 
                                                                '&relateCanceledId='  + data.relateCanceledId  +  
                                                                '&role='              + data.role         );
  }

  /* NUEVA FUNCION 08/04/2022 POR YESENIA.CANO */

  getInvoiceTotalReportProp3(data):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getInvoiceTotalReportPropV3?businessId="  + data.businessId     + 
                                                                // '&instId='            + data.instId  +  
                                                                '&startDate='             + data.startDate   +  
                                                                '&endDate='               + data.endDate);
  }
  getItsUnderMaintenance(module):Observable<any[]>{
    return this.httpClient.get<any[]>(this.urlBase + "getItsUnderMaintenance?module=" +module);
  }

  updateMessage(data):Observable<any[]>{
    return this.httpClient.post<any[]>(this.urlBase + "updateMessage?check="       + data.check       ,data);
  }
}
